export default {
  name: "DeleteGroupDialog",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Function,
      default: () => {}
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
    chat: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    show(val) {
      this.showModal = val;
    }
  },
  created() {
    this.showModal = this.show;
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    confirm() {
      this.onConfirm({title: "Delete Chat"});
      this.hide();
    },
    hideModal() {
      this.showModal = false;
      this.hide();
    }
  }
}